/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Decoupling_RangeInputs */

const en_exp_decoupling_range = /** @type {(inputs: Exp_Decoupling_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below 5 %: well paced, your aerobic base held up. 5–10 %: noticeable drift. Above 10 %: the session outlasted your endurance. Below 0 %: you got more efficient.`)
};

const de_exp_decoupling_range = /** @type {(inputs: Exp_Decoupling_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 5 %: gleichmäßig — deine Grundlage hat gehalten. 5–10 %: du driftest spürbar. Über 10 %: die Einheit war länger als deine Ausdauer. Unter 0 %: du bist effizienter geworden.`)
};

/**
* | output |
* | --- |
* | "Below 5 %: well paced, your aerobic base held up. 5–10 %: noticeable drift. Above 10 %: the session outlasted your endurance. Below 0 %: you got more efficient." |
*
* @param {Exp_Decoupling_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_decoupling_range = /** @type {((inputs?: Exp_Decoupling_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Decoupling_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_decoupling_range(inputs)
	return de_exp_decoupling_range(inputs)
});